import { useEffect } from "react";

import {
  connectWoTechStatusSocket,
  disconnectWoTechStatusSocket,
} from "src/Services/socket/woTechStatusSocket";

const useWoTechStatusRealtime = ({ woId, onTechStatusChanged }) => {
  useEffect(() => {
    if (!woId) {
      return undefined;
    }

    const socket = connectWoTechStatusSocket();
    const roomPayload = { woId };

    const joinRoom = () => {
      socket.emit("wo-tech-status:join", roomPayload);
    };

    const handleTechStatusChanged = (payload) => {
      if (Number(payload?.woId) !== Number(woId)) {
        return;
      }
      onTechStatusChanged?.(payload);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }
      connectWoTechStatusSocket();
      joinRoom();
    };

    socket.on("connect", joinRoom);
    socket.on("wo-tech-status-changed", handleTechStatusChanged);

    if (socket.connected) {
      joinRoom();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      socket.off("connect", joinRoom);
      socket.off("wo-tech-status-changed", handleTechStatusChanged);
      socket.emit("wo-tech-status:leave", roomPayload);
      disconnectWoTechStatusSocket();
    };
  }, [woId, onTechStatusChanged]);
};

export default useWoTechStatusRealtime;
